import { UtcDate } from '@/helpers/date';

const defaultMsg = 'Please select an option from this list.';
const ageMsg = 'Driver is too young to have that many years NCD. Please review.';

export default {
  computesRequired: true,
  params: [
    'dateOfBirth',
    'dateOfInsuranceStart',
    'noValidationYears',
  ],
  validate (value, { dateOfBirth, dateOfInsuranceStart, noValidationYears = 2 }) {
    if ([undefined, null, ''].includes(value)) return defaultMsg;
    if (value <= noValidationYears) return true;

    const birthDate = new UtcDate(dateOfBirth);
    const today = new UtcDate();
    const dateOfInsuranceStartDate = new UtcDate(dateOfInsuranceStart);
    const maxDate = dateOfInsuranceStartDate.isValid() ? dateOfInsuranceStartDate : today.addDays(this.constants.DATE_OF_INSURANCE_START_MAX_DAYS);
    const age = (dateOfBirth && birthDate.isValid()) ? maxDate.differenceInYears(birthDate) : null;
    const minAge = this.constants.NCD_MIN_AGE;

    if (!age) return ageMsg;
    if (age >= minAge && (+value > (age + noValidationYears - minAge))) return ageMsg;

    return true;
  },
};
